module.exports = __webpack_public_path__ + "img/crna-logs.1ad9d143.png";